import * as angular from 'angular';
import { LoyaltyPointsRouter } from 'OpsCenter/ops-support/loyalty-points/loyalty-points.router';
import { downgradeComponent } from '@angular/upgrade/static';
import { LoyaltyPointsComponent } from 'OpsCenter/ops-support/loyalty-points/loyalty-points.component';

const loyaltyPointsModule = angular
  .module('ec.opsCenter.ops-support.loyalty-points', [])
  .config(LoyaltyPointsRouter)
  .directive('appLoyaltyPoints', downgradeComponent({ component: LoyaltyPointsComponent }) as angular.IDirectiveFactory).name;

export default loyaltyPointsModule;



// WEBPACK FOOTER //
// ./src/app/ops-support/loyalty-points/loyalty-points.module.ajs.ts